import { render, staticRenderFns } from "./crud-empCategory.vue?vue&type=template&id=48324e51&scoped=true"
import script from "./crud-empCategory.vue?vue&type=script&lang=js"
export * from "./crud-empCategory.vue?vue&type=script&lang=js"
import style0 from "./crud-empCategory.vue?vue&type=style&index=0&id=48324e51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48324e51",
  null
  
)

export default component.exports